/*
|--------------------------------------------------------------------------
| OFFER STATUS
|--------------------------------------------------------------------------
*/

export const OFFER_STATUS = {
  DRAFT: "DRAFT",
  SENT: "SENT",
  VIEWED: "VIEWED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED"
};


/*
|--------------------------------------------------------------------------
| OFFER STATUS LABELS
|--------------------------------------------------------------------------
*/

export const OFFER_STATUS_LABELS = {
  [OFFER_STATUS.DRAFT]: "Draft",
  [OFFER_STATUS.SENT]: "Sent",
  [OFFER_STATUS.VIEWED]: "Viewed",
  [OFFER_STATUS.ACCEPTED]: "Accepted",
  [OFFER_STATUS.REJECTED]: "Rejected",
  [OFFER_STATUS.EXPIRED]: "Expired",
  [OFFER_STATUS.CANCELLED]: "Cancelled"
};


/*
|--------------------------------------------------------------------------
| OFFER STATUS TRANSITIONS
|--------------------------------------------------------------------------
*/

export const OFFER_STATUS_TRANSITIONS = {
  [OFFER_STATUS.DRAFT]: [
    OFFER_STATUS.SENT,
    OFFER_STATUS.CANCELLED
  ],

  [OFFER_STATUS.SENT]: [
    OFFER_STATUS.VIEWED,
    OFFER_STATUS.ACCEPTED,
    OFFER_STATUS.REJECTED,
    OFFER_STATUS.EXPIRED,
    OFFER_STATUS.CANCELLED
  ],

  [OFFER_STATUS.VIEWED]: [
    OFFER_STATUS.ACCEPTED,
    OFFER_STATUS.REJECTED,
    OFFER_STATUS.EXPIRED,
    OFFER_STATUS.CANCELLED
  ],

  [OFFER_STATUS.ACCEPTED]: [],

  [OFFER_STATUS.REJECTED]: [],

  [OFFER_STATUS.EXPIRED]: [],

  [OFFER_STATUS.CANCELLED]: []
};


/*
|--------------------------------------------------------------------------
| STATUS COLORS
|--------------------------------------------------------------------------
*/

export const OFFER_STATUS_COLORS = {
  [OFFER_STATUS.DRAFT]: "gray",
  [OFFER_STATUS.SENT]: "blue",
  [OFFER_STATUS.VIEWED]: "indigo",
  [OFFER_STATUS.ACCEPTED]: "green",
  [OFFER_STATUS.REJECTED]: "red",
  [OFFER_STATUS.EXPIRED]: "orange",
  [OFFER_STATUS.CANCELLED]: "slate"
};


/*
|--------------------------------------------------------------------------
| DEFAULT VALUES
|--------------------------------------------------------------------------
*/

export const DEFAULT_CURRENCY = "INR";

export const DEFAULT_QUANTITY = 1;

export const DEFAULT_ITEM_DISCOUNT = 0;

export const DEFAULT_ITEM_TAX = 0;

export const DEFAULT_OFFER_DISCOUNT = 0;

export const DEFAULT_OFFER_TAX = 0;


/*
|--------------------------------------------------------------------------
| PRICING TYPES
|--------------------------------------------------------------------------
|
| These correspond to pricing_plans.pricing_type.
|
*/

export const PRICING_TYPE = {
  FIXED: "FIXED",
  CUSTOM: "CUSTOM"
};


/*
|--------------------------------------------------------------------------
| OFFER DEFAULT FORM
|--------------------------------------------------------------------------
*/

export const DEFAULT_OFFER_FORM = {
  queryId: "",
  currency: DEFAULT_CURRENCY,
  discountAmount: DEFAULT_OFFER_DISCOUNT,
  taxAmount: DEFAULT_OFFER_TAX,
  validUntil: "",
  notes: "",
  items: []
};


/*
|--------------------------------------------------------------------------
| DEFAULT OFFER ITEM
|--------------------------------------------------------------------------
*/

export const DEFAULT_OFFER_ITEM = {
  offeringId: "",
  pricingPlanId: "",
  description: "",
  quantity: DEFAULT_QUANTITY,
  unitPrice: "",
  discountAmount: DEFAULT_ITEM_DISCOUNT,
  taxAmount: DEFAULT_ITEM_TAX
};


/*
|--------------------------------------------------------------------------
| OFFER FILTER DEFAULTS
|--------------------------------------------------------------------------
*/

export const DEFAULT_OFFER_FILTERS = {
  status: "",
  clientId: "",
  queryId: ""
};